<template>
  <div class="container-fluid mt-2">
    <div class="row">
      <global-loading />
      <div class="col-2"><admin-menu /></div>
      <div class="col-10">
        <router-view name="default" />
      </div>
    </div>
  </div>
</template>
<script>
import '@/assets/css/admin.css'
import '@/assets/css/quill_fix.css'
import AdminMenu from '@/components/AdminMenu'
import GlobalLoading from '@/components/GlobalLoading'
import axios from 'axios'
import {actionTypes as appActions} from '@/store/modules/app'

export default {
  components: {AdminMenu, GlobalLoading},
  mounted() {
    axios.interceptors.request.use((config) => {
      this.$store.dispatch(appActions.setGlobalLoading, {loading: true})
      return config
    })
    axios.interceptors.response.use(
        (response) => {
      this.$store.dispatch(appActions.setGlobalLoading, {loading: false})
      return response
      },
      (error) => {
        this.$store.dispatch(appActions.setGlobalLoading, {loading: false})
        return Promise.reject(error)
      }
    )
  },
}
</script>
